// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3teTq","overflowing":"ReadFullNote_overflowing__2UQTm"};